import { symbology } from '../utils/Symbology';

export const PUBLIC_URL = process.env?.PUBLIC_URL || 'http://localhost:3000';

export const DATA_URL = PUBLIC_URL + '/data';

export const cdcSite = window.location.href.indexOf('https://wcms-wp.cdc.gov/') === -1 ? 'https://www.cdc.gov/' : 'https://wcms-wp.cdc.gov/';

const getListObject = (list, idOrSlug) => {
    return list.find((sc) => sc.slug === idOrSlug || sc.id === idOrSlug);
};

export const viewTypeList = [
    { id: 0, label: 'Deaths', slug: 'deaths', scales: ['usstate', 'county', 'census'], years: '*' },
    { id: 1, label: 'Emergency Department Visits', slug: 'ed_visits', scales: ['usstate', 'county', 'zcta'], years: 'ttm,2023,2022' }
];

export const getViewTypeObject = (idOrSlug) => {
    return getListObject(viewTypeList, idOrSlug);
};

export const scaleListv1 = [
    { id: 0, trendID: 1, label: 'State', slug: 'usstate', minZoom: 0, 'source-layer': 'State', lineWidth: 2, years: '*' },
    { id: 1, trendID: 2, label: 'County', slug: 'county', minZoom: 0, 'source-layer': 'County', lineWidth: 1, years: '*' },
    { id: 3, trendID: 3, label: 'Census Tract', slug: 'census', minZoom: 0, 'source-layer': 'Tract', lineWidth: 0.5, years: 'ttm,2023,2022' },
    { id: 2, trendID: 4, label: 'ZIP Code', slug: 'zcta', minZoom: 0, 'source-layer': 'ZCTA', lineWidth: 0.5, years: 'ttm,2023,2022' }
];
export const scaleListv2 = [
    { id: 10, trendID: 10, label: 'State', slug: 'usstate', minZoom: 0, 'source-layer': 'State', lineWidth: 2, years: '*' },
    { id: 20, trendID: 20, label: 'County', slug: 'county', minZoom: 0, 'source-layer': 'County', lineWidth: 1, years: '*' },
    { id: 30, trendID: 30, label: 'Census Tract', slug: 'census', minZoom: 0, 'source-layer': 'Tract', lineWidth: 0.5, years: 'ttm,2023,2022' },
    { id: 40, trendID: 40, label: 'ZIP Code', slug: 'zcta', minZoom: 0, 'source-layer': 'ZCTA', lineWidth: 0.5, years: 'ttm,2023,2022' }
];

export const getScaleObject = (idOrSlug) => {
    if (idOrSlug + '' === '0' || idOrSlug === 'us') return { id: 0, trendID: 0, label: 'United States', slug: 'us', 'source-layer': '', lineWidth: 0, years: '*' };
    return getListObject(scaleList, idOrSlug);
};

export const convertScaleValues = (key) => {
    let scaleOBj = {
        usstate: () => {
            return 'geoid';
        },
        county: () => {
            return 'geoid';
        },
        default: () => {
            return 'st_name';
        }
    };
    return (scaleOBj[key] || scaleOBj['default'])();
};

export const timePeriodList = [
    { id: 0, label: 'Recent 12 months', attr: 'TTM', slug: 'ttm' },
    { id: 1, label: '2023', attr: '2023', slug: '2023' },
    { id: 2, label: '2022', attr: '2022', slug: '2022' },
    { id: 3, label: '2021', attr: '2021', slug: '2021' },
    { id: 4, label: '2020', attr: '2020', slug: '2020' },
    { id: 5, label: '2019', attr: '2019', slug: '2019' }
];

export const getTimePeriodObject = (idOrSlug) => {
    return getListObject(timePeriodList, idOrSlug);
};

export const deathTypeListv1 = [
    { id: 0, label: 'All Firearm Injury Deaths', attr: 'ALL', slug: 'all', title: 'All Firearm Injury Deaths', causeStr: 'from any type of firearm injury' },
    { id: 1, label: 'Firearm Homicide', attr: 'Homicide', slug: 'homicide', title: 'Firearm Homicide', causeStr: 'from firearm homicide' },
    { id: 2, label: 'Firearm Suicide', attr: 'Suicide', slug: 'suicide', title: 'Firearm Suicide', causeStr: 'by firearm suicide' }
];
export const deathTypeListv2 = [
    // { id: 0, label: 'All Firearm Injury Deaths', attr: 'fa_deaths', slug: 'fa_deaths', indent: false },
    { id: 3, label: 'Unintentional Drug Overdose', attr: 'drug_od', slug: 'drug_od', indent: false, title: 'Unintentional Drug Overdose Deaths', causeStr: 'from an unintentional or undetermined intent drug overdose', causeStrAlt: 'unintentional or undetermined intent drug overdose deaths' },
    { id: 4, label: 'Suicide', attr: 'all_suicide', slug: 'all_suicide', indent: false, title: 'Suicide', causeStr: 'from suicide', causeStrAlt: 'suicide deaths' },
    { id: 2, label: 'Firearm Suicide', attr: 'fa_suicide', slug: 'fa_suicide', indent: true, title: 'Firearm Suicide', causeStr: 'from firearm suicide', causeStrAlt: 'firearm suicide' },
    { id: 5, label: 'Homicide', attr: 'all_homicide', slug: 'all_homicide', indent: false, title: 'Homicide', causeStr: 'from homicide', causeStrAlt: 'homicide deaths' },
    { id: 1, label: 'Firearm Homicide', attr: 'fa_homicide', slug: 'fa_homicide', indent: true, title: 'Firearm Homicide', causeStr: 'from firearm homicide', causeStrAlt: 'firearm homicide' },
    { id: 0, label: 'All Firearm Injury Deaths', attr: 'fa_deaths', slug: 'fa_deaths', indent: false, title: 'All Firearm Injury Deaths', causeStr: 'from any type of firearm injury', causeStrAlt: 'all firearm injury deaths' }
];
export const getDeathTypeObject = (idOrSlug) => {
    return getListObject(deathTypeList, idOrSlug);
};

export const measurmentTypeList = [
    { id: 0, label: 'Rate per 100k', attr: 'Rate', slug: 'rate', view: 'deaths' },
    { id: 1, label: 'Count', attr: 'Count', slug: 'count', view: 'deaths' },
    { id: 2, label: 'Rate per 100k ED visits', attr: 'Rate', slug: 'rate', view: 'ed_visits' }
];

export const getMeasurmentTypeObject = (idOrSlug) => {
    return getListObject(measurmentTypeList, idOrSlug);
};

export { symbology };

const downloadFields_v1 = {
    usstate: 'geoid,name,period,count_sup_all,count_sup_homicide,count_sup_suicide,rate_all,rate_homicide,rate_suicide,rate_ed',
    county: 'geoid,name,st_name,period,count_sup_all,count_sup_homicide,count_sup_suicide,rate_all,rate_homicide,rate_suicide,rate_m_all,rate_m_homicide,rate_m_suicide,rate_m_ci_all,rate_m_ci_homicide,rate_m_ci_suicide,rate_ed,rate_m_ed,rate_m_ci_ed',
    census: 'geoid,name,st_name,period,count_sup_all,count_sup_homicide,count_sup_suicide,rate_all,rate_homicide,rate_suicide,rate_m_all,rate_m_homicide,rate_m_suicide,rate_m_ci_all,rate_m_ci_homicide,rate_m_ci_suicide',
    zcta: 'geoid,name,st_name,period,rate_ed,rate_m_ed,rate_m_ci_ed'
};

const downloadFields_v2 = {
    usstate: 'geoid,name,period,count_sup_all_homicide,count_sup_all_suicide,count_sup_drug_od,count_sup_fa_deaths,count_sup_fa_homicide,count_sup_fa_suicide,rate_all_homicide,rate_all_suicide,rate_drug_od,rate_fa_deaths,rate_fa_homicide,rate_fa_suicide',
    county: 'geoid,name,st_name,period,count_sup_all_homicide,count_sup_all_suicide,count_sup_drug_od,count_sup_fa_deaths,count_sup_fa_homicide,count_sup_fa_suicide,rate_all_homicide,rate_all_suicide,rate_drug_od,rate_fa_deaths,rate_fa_homicide,rate_fa_suicide,rate_m_all_homicide,rate_m_all_suicide,rate_m_drug_od,rate_m_fa_deaths,rate_m_fa_homicide,rate_m_fa_suicide,rate_m_ci_all_homicide,rate_m_ci_all_suicide,rate_m_ci_drug_od,rate_m_ci_fa_deaths,rate_m_ci_fa_homicide,rate_m_ci_fa_suicide',
    census: 'geoid,name,st_name,period,count_sup_all_homicide,count_sup_all_suicide,count_sup_drug_od,count_sup_fa_deaths,count_sup_fa_homicide,count_sup_fa_suicide,rate_all_homicide,rate_all_suicide,rate_drug_od,rate_fa_deaths,rate_fa_homicide,rate_fa_suicide,rate_m_all_homicide,rate_m_all_suicide,rate_m_drug_od,rate_m_fa_deaths,rate_m_fa_homicide,rate_m_fa_suicide,rate_m_ci_all_homicide,rate_m_ci_all_suicide,rate_m_ci_drug_od,rate_m_ci_fa_deaths,rate_m_ci_fa_homicide,rate_m_ci_fa_suicide',
    zcta: 'geoid,name,st_name,period'
};

export const endpointsv1 = {
    useToken: false,
    trends: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/FA/FA_Trend_Chart_Data/MapServer/',
    map: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/Hosted/Dashboard_',
    features: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/Hosted/Dashboard_',
    downloadFields: downloadFields_v1
};

export const endpointsv2 = {
    useToken: false,
    trends: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/FA/FA_Trend_Chart_Data/MapServer/',
    map: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/FA/FA_Map_Data_',
    features: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/FA/FA_Map_Data_',
    downloadFields: downloadFields_v1
};

export const onemapendpoints = {
    useToken: true,
    trends: 'https://onemap.cdc.gov/onemapservices/rest/services/FA/FA_Trend_Chart_Data/MapServer/',
    map: 'https://onemap.cdc.gov/onemapservices/rest/services/FA/FA_Map_Data_',
    features: 'https://onemap.cdc.gov/onemapservices/rest/services/FA/FA_Map_Data_',
    downloadFields: downloadFields_v1
};

//new death endpoints
export const endpointsv3 = {
    useToken: false,
    trends: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/NCIPC/NCIPC_Dashboard_Chart/MapServer/',
    map: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/NCIPC/NCIPC_Dashboard_Map_',
    features: 'https://witv-grsp-5.cdc.gov/onemapservices/rest/services/NCIPC/NCIPC_Dashboard_Map_',
    downloadFields: downloadFields_v2
};
//new death endpoints
export const endpointsv4 = {
    useToken: false,
    trends: 'https://onemap.cdc.gov/onemapservices/rest/services/NCIPC/NCIPC_Dashboard_Chart/MapServer/',
    map: 'https://onemap.cdc.gov/onemapservices/rest/services/NCIPC/NCIPC_Dashboard_Map_',
    features: 'https://onemap.cdc.gov/onemapservices/rest/services/NCIPC/NCIPC_Dashboard_Map_',
    downloadFields: downloadFields_v2
};

const getSearchParams = function (url) {
    if (url.indexOf('?') === -1) return {};
    var search = url.substring(url.indexOf('?') + 1);
    return Object.fromEntries(new URLSearchParams(search));
};

var params = getSearchParams(window.location.href);
var useHalf = params.data === 'half';

export const deathTypeList = deathTypeListv2;
export const scaleList = scaleListv2;
export const endpoints = useHalf ? endpointsv3 : endpointsv4;

// export const deathTypeList = deathTypeListv2;
// export const scaleList = scaleListv2;
// export { endpointsv4 as endpoints };

// export const deathTypeList = deathTypeListv2;
// export const scaleList = scaleListv2;
// export { endpointsv3 as endpoints };

// export const deathTypeList = deathTypeListv1;
// export const scaleList = scaleListv1;
// export { endpointsv2 as endpoints };

// export const deathTypeList = deathTypeListv1;
// export const scaleList = scaleListv1;
// export { onemapendpoints as endpoints };
